'use client';

import React from 'react';
import View from '../view';
import { Link } from '@/navigation';
import Markdown from 'markdown-to-jsx';
import Detailed from '../details/card';

type Props = {
  content: any;
};

const SectionStatic: React.FC<Props> = ({ content }) => {
  return (
    <Markdown
      options={{
        overrides: {
          h2: {
            component: (props) => (
              <Detailed.Heading color="success" className="flex">
                {props.children}
              </Detailed.Heading>
            ),
          },
          blockquote: {
            component: (props) => (
              <View className="flex items-center py-2">
                <Detailed.Blockquote>{props.children}</Detailed.Blockquote>
              </View>
            ),
          },
          p: {
            component: (props) => (
              <View className="flex items-center py-2">
                <Detailed.Description>{props.children}</Detailed.Description>
              </View>
            ),
          },
          a: {
            component: (props) => (
              <Link href={props.href} className="flex">
                <View className="flex items-center gap-1 text-[var(--app-color-green)] font-bold hover:underline">
                  <span>{props.children}</span>
                </View>
              </Link>
            ),
          },
        },
      }}
    >
      {content}
    </Markdown>
  );
};

export default SectionStatic;
